/* tslint:disable */
/* eslint-disable */
// @ts-nocheck
/**
 * Audius API
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ClaimRewardsRequestBody
 */
export interface ClaimRewardsRequestBody {
    /**
     * The challenge ID to filter rewards (optional)
     * @type {string}
     * @memberof ClaimRewardsRequestBody
     */
    challengeId?: string;
    /**
     * The specifier to filter rewards (optional)
     * @type {string}
     * @memberof ClaimRewardsRequestBody
     */
    specifier?: string;
    /**
     * The user ID to claim rewards for
     * @type {string}
     * @memberof ClaimRewardsRequestBody
     */
    userId: string;
}

/**
 * Check if a given object implements the ClaimRewardsRequestBody interface.
 */
export function instanceOfClaimRewardsRequestBody(value: object): value is ClaimRewardsRequestBody {
    let isInstance = true;
    isInstance = isInstance && "userId" in value && value["userId"] !== undefined;

    return isInstance;
}

export function ClaimRewardsRequestBodyFromJSON(json: any): ClaimRewardsRequestBody {
    return ClaimRewardsRequestBodyFromJSONTyped(json, false);
}

export function ClaimRewardsRequestBodyFromJSONTyped(json: any, ignoreDiscriminator: boolean): ClaimRewardsRequestBody {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'challengeId': !exists(json, 'challengeId') ? undefined : json['challengeId'],
        'specifier': !exists(json, 'specifier') ? undefined : json['specifier'],
        'userId': json['userId'],
    };
}

export function ClaimRewardsRequestBodyToJSON(value?: ClaimRewardsRequestBody | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'challengeId': value.challengeId,
        'specifier': value.specifier,
        'userId': value.userId,
    };
}

